import { RegisterAdminRequest, RegisterAdminResponse } from '../registeradmin';
import * as _m0 from "protobufjs/minimal";
import { withAuthRetry } from '../utils/authRetry';

export async function registerAdmin(
    request: RegisterAdminRequest,
    accessToken: string,
    setAccessToken: (token: string | null) => void,
    logout: () => void
): Promise<RegisterAdminResponse> {
    const originalApiCall = async (token: string): Promise<Response> => {
        const encodedRequest = RegisterAdminRequest.encode(request).finish();
        const base64 = _m0.util.base64.encode(encodedRequest, 0, encodedRequest.length);

        const params = new URLSearchParams(window.location.search);
        const staging = params.get('stagingEnv')?.toLowerCase() === 'true';

        let url = "https://rnmjoi8ycf.execute-api.us-west-2.amazonaws.com/adminservice/registeradmin";
        if (staging) {
            url = `${url}-staging`;
        }

        const response = await fetch(
            url, {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${token}`
            },
            body: base64
        }
        );
        return response;
    };

    const decodeResponse = (bytes: Uint8Array): RegisterAdminResponse => {
        return RegisterAdminResponse.decode(bytes);
    };

    return withAuthRetry(originalApiCall, accessToken, decodeResponse, setAccessToken, logout);
}
